var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAerospaceDefence(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3335 15.3335L16.1225 12.0823C15.6605 11.7256 15.2745 11.2851 14.9795 10.7915V20.2743H20.3335V15.3335Z",
    fill: "#806D57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68699 10.7915C5.39199 11.2851 5.00602 11.7256 4.54394 12.0823L0.333008 15.3335V20.2742H5.68699V10.7915Z",
    fill: "#806D57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9883 21.6016H14.9794V22.929H12.9883V21.6016Z",
    fill: "#806D57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00586 21.6016H11.6607V22.929H9.00586V21.6016Z",
    fill: "#806D57"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68652 21.6016H7.67767V22.929H5.68652V21.6016Z",
    fill: "#806D57"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6518 5.70339V5.62596C13.6518 3.28065 12.3 1.2514 10.3332 0.273926C8.36646 1.2514 7.01465 3.28065 7.01465 5.62596V5.70339H13.6518Z",
    fill: "#806D57"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6518 7.03125H7.01465V20.2743H13.6518V7.03125ZM12.3244 8.35868V9.68612H8.34208V8.35868H12.3244Z",
    fill: "#806D57"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAerospaceDefence);
export default __webpack_public_path__ + "static/media/Aerospace&Defence.fb529a481ade3cd07b4f8cdff50bf282.svg";
export { ForwardRef as ReactComponent };